import { getListPendingAttestationsQueryKey } from '@moment/horizon-data-access/platform'

import { COPILOT_SURFACE } from '@/attestation/copilot-surface'

/**
 * Reopens the gate after the API rejects a call for an outstanding document.
 *
 * The gate only queries on mount, so a document published — or a
 * re-attestation window that lapses — while the user already has an AI surface
 * open is invisible to it. Refetching the pending list is what turns that 403
 * into a prompt the user can actually clear.
 */
export function reportAttestationRequired(): void {
  // Imported lazily so the query client stays out of api/base-api-slice's
  // static graph: get-query-client resolves a generated query key at module
  // scope, which throws in suites that mock the generated module.
  void import(
    '@/components/config/horizon-query-provider/get-query-client'
  ).then(({ getQueryClient }) =>
    getQueryClient().invalidateQueries({
      queryKey: getListPendingAttestationsQueryKey(COPILOT_SURFACE.params),
    }),
  )
}
